import { render } from "./CronJobs.vue?vue&type=template&id=52fea352&scoped=true"
import script from "./CronJobs.vue?vue&type=script&lang=js"
export * from "./CronJobs.vue?vue&type=script&lang=js"

import "./CronJobs.vue?vue&type=style&index=0&id=52fea352&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/xsurflog_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52fea352"]])

export default __exports__